import Top100Event from 'shared/types/top100';

const trackEvent = (event?: Top100Event | string) => {
  if (event) {
    (window as any).top100Counter?.trackEvent(event);
  }
};

export default trackEvent;
